import React from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'
import { includes } from 'lodash'
import Modal from 'react-responsive-modal'
import PopularAttractionActions from '../../Redux/PopularAttractionRedux'
import FormCreate from '../../Containers/PopularAttraction/FormCreate'
import FormEdit from '../../Containers/PopularAttraction/FormEdit'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class Popular extends React.Component {
  constructor (props) {
    super(props)

    this.options = [
      { value: 'id', label: 'Passpod ID', restriction: ['PH'] },
      { value: 'sg', label: 'Passpod SG', restriction: ['PH'] },
      { value: 'ph', label: 'Passpod PH' }
    ].filter((option) => { return (!includes(option.restriction, currentBranch())) })

    this.state = {
      modifier: 'origin',
      modifier_value: currentBranch(),
      reverse: false,
      showModal: null,
      detail: {},
      filter: {
        title: ''
      }
    }
  }

  componentDidMount = () => {
    this._getList()
  }

  _inputChange = (event, field) => {
    const val = event.target.value
    let newState = { ...this.state }
    newState[field] = val
    this.setState(newState)

    if (field === 'modifier_value') {
      setTimeout(() => {
        this._getList()
      }, 250)
    }
  }

  _getList = () => {
    const { modifier, modifier_value } = this.state
    const data = { modifier, modifier_value }
    this.props.getPopularAttraction(data)
  }

  _reverseOrder = () => {
    this.setState({
      reverse: !this.state.reverse
    })

    $('tbody').each(function (elem, index) {
      let arr = $.makeArray($('tr', this).detach())
      arr.reverse()
      $(this).append(arr)
    })
  }

  _toggleModal = (modalId = null, detail = {}) => {
    this.setState({
      showModal: modalId,
      detail
    })

    if (!modalId) {
      setTimeout(() => {
        this._getList()
      }, 250)
    }
  }

  _delete = () => {
    const id = this.state.detail.popularity_id
    this.props.deletePopularAttraction(id)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _filterChange = (event, field) => {
    let newState = { ...this.state.filter }
    const val = event.target.value
    newState[field] = val
    this.setState({ filter: newState })

    if (field === 'title') {
      $.expr[':'].contains = function (a, i, m) {
        return $(a).text().toUpperCase()
          .indexOf(m[3].toUpperCase()) >= 0
      }
      if (val) {
        $('td[data-filter="title"]:not(:contains("' + val + '"))').parent().hide()
        $('td[data-filter="title"]:contains("' + val + '")').parent().show()
      } else {
        $('tr:hidden').show()
      }
    }
  }

  render () {
    const { popularAttraction } = this.props

    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Popular Attraction
              {
                (popularAttraction.fetching || popularAttraction.processing) &&
                <div className='badge badge-info ml-2'>{popularAttraction.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('create')}><i className='fa fa-plus' /> Add New</button>
          </div>
          <div className='title-block'>
            <div className='form-inline d-flex justify-content-between'>
              <div className='form-inline'>
                <div className='form-group'>
                  <label className='control-label'>Origin</label>
                </div>
                <div className='form-group ml-2'>
                  <select name='modifier_value' className='form-control' value={this.state.modifier_value} onChange={(event) => this._inputChange(event, 'modifier_value')}>
                    <option value='' disabled>- Select Origin -</option>
                    {
                      this.options.map((item, i) => (
                        <option key={i} value={item.value}>{item.label}</option>
                      ))
                    }
                  </select>
                </div>
              </div>
              <div className='form-group'>
                <label className='control-label mr-2'>Search by title</label>
                <input type='text' name='title' className='form-control' onChange={event => this._filterChange(event, 'title')} />
              </div>
            </div>
          </div>
        </header>
        <section className='section'>
          <div className='card'>
            {
              !(popularAttraction.fetching || popularAttraction.processing) && popularAttraction.err &&
              <div className='alert alert-danger'>{popularAttraction.err}</div>
            }
            {this.state.modifier_value &&
              <div className='card-block'>
                <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
                  <thead>
                    <tr>
                      <th>Attraction Title</th>
                      <th role='button' onClick={() => this._reverseOrder()}>Priority <span className='badge badge-info'><i className={`fas fa-${this.state.reverse ? 'sort-numeric-down' : 'sort-numeric-up'}`} /></span></th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!popularAttraction.data || !popularAttraction.data.length
                      ? <tr>
                        <td colSpan='4' className='text-center'> - NO DATA - </td>
                      </tr>
                      : popularAttraction.data.map((item, i) => (
                        <tr key={i}>
                          <td data-filter='title'>{ item.title || '-' }</td>
                          <td>{ item.priority }</td>
                          <td>
                            <button className='btn btn-info' onClick={() => this._toggleModal('edit', item)}>
                              <i className='fas fa-edit' />
                            </button>
                          </td>
                          <td>
                            <button className='btn btn-danger' onClick={() => this._toggleModal('delete', item)}>
                              <i className='fa fa-trash' />
                            </button>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>

          <Modal open={this.state.showModal === 'create'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormCreate closeModal={() => this._toggleModal()} />
          </Modal>

          <Modal open={this.state.showModal === 'edit'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormEdit detail={this.state.detail} closeModal={() => this._toggleModal()} />
          </Modal>

          <Modal open={this.state.showModal === 'delete'} onClose={this._toggleModal} closeOnOverlayClick>
            <section className='section' style={{ width: '40vw' }}>
              <div className='title-block'>
                <h3>Delete Popular Attraction?</h3>
              </div>
              <div className='text-center'>
                <p>{ this.state.detail.title || '-' }</p>
              </div>
              <div className='d-flex justify-content-center'>
                <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
                <button className='btn btn-lg btn-danger' onClick={() => this._delete()}>Delete</button>
              </div>
            </section>
          </Modal>
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  popularAttraction: state.popularAttraction
})

const dispatchToProps = (dispatch) => ({
  getPopularAttraction: (data) => dispatch(PopularAttractionActions.popularAttractionRequest(data)),
  deletePopularAttraction: (id) => dispatch(PopularAttractionActions.popularAttractionDeleteRequest(id))
})

export default connect(stateToProps, dispatchToProps)(Popular)



// WEBPACK FOOTER //
// ./src/Pages/Attraction/Popular.js